(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__fpBundleExpressToggle) return;
    window.__fpBundleExpressToggle = true;

    var BODY_CLASS = 'fp-bundle-multipack-selected';
    var AOV_SELECTOR = '.Avada-Bundle-Offer__Volume, [id*="aov_ai_bundle"]';

    function multipackSelected() {
      var container = document.querySelector(AOV_SELECTOR);
      if (!container) return false;
      var selected = container.querySelector('.Avada-Volume__Item--Selected') || container.querySelector('.Avada-Volume__Item[aria-checked="true"]');
      if (!selected) return false;
      var text = selected.textContent || '';
      var hashCount = text.split('#').length - 1;
      if (hashCount > 1) return true;
      var lower = text.toLowerCase();
      if (lower.indexOf('single') === -1 && lower.indexOf('pack') !== -1 && lower.indexOf('1 pack') === -1 && lower.indexOf('1pack') === -1) return true;
      return false;
    }

    function apply() {
      document.body.classList.toggle(BODY_CLASS, multipackSelected());
    }

    var timer;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(apply, 60);
    }

    var observing = false;
    function startObserving() {
      var container = document.querySelector(AOV_SELECTOR);
      if (!container || observing) return;
      observing = true;
      new MutationObserver(schedule).observe(container, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
      apply();
    }

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest(AOV_SELECTOR)) schedule();
    }, true);

    [0, 500, 1500, 3000].forEach(function (d) { setTimeout(startObserving, d); });
    if (document.readyState !== 'loading') startObserving();
    else document.addEventListener('DOMContentLoaded', startObserving);
  })();
  } catch(e) { console.error(e); }
})();

})();
